import { z } from 'zod';

import { CmsImage, CmsUrl, ImageSizeStyle } from '../models';
import { BasePType } from './base';

export const Image = BasePType.extend({
  type: z.enum(['image']),
  topLeft: z.boolean().optional(),
  analyticsLinkText: z.string().nullable().optional(),
  imageHeight: z.string().nullable(),
  imageSize: z.nullable(ImageSizeStyle).optional(),
  imageSizeMobile: z.nullable(ImageSizeStyle).optional(),
  imageWidth: z.string().nullable(),
  url: z.nullable(CmsUrl),
  webpMedia: z.nullable(CmsImage).optional(),
  webpMediaMid: z.nullable(CmsImage).optional(),
  webpMediaDesktop: z.nullable(CmsImage).optional(),
  id: z.number().nullable().optional(),
  parentType: z.string().nullable().optional(),
  revisionId: z.number().nullable().optional(),
  status: z.boolean().nullable().optional(),
  uuid: z.string().nullable().optional(),
});

export type Image = z.infer<typeof Image>;
